module.exports = function anonymous(it
) {
var out='<span class="js-error help-inline" data-type="'+(it.type)+'">'+(it.msg)+'</span>';return out;
}